import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo/biam_white.svg";
import { signOut } from 'firebase/auth';
import { MdClose, MdMenu } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { FaPowerOff } from "react-icons/fa";
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import Modal from '../components/Modal/Modal';
import { auth, db } from '../firebase';


const DashboardLayout = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // burger menu

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const activeSidenavLinkCss = 'bg-tangerine flex justify-start items-center gap-[10px] p-4 cursor-pointer text-white text-[14px] font-bold rounded w-[80%]';
  const sidenavLinkCss = 'flex justify-start items-center text-white gap-[10px] p-4 cursor-pointer text-[14px] rounded w-[80%] hover:bg-grey';

  const sidebarList = [
    {
      label: 'Dashboard',
      link: '/dashboard/',
      roles: ['admin', 'editor', 'author'],
    },
    {
      label: 'Media',
      link: '/dashboard/blogapp',
      roles: ['admin', 'editor', 'author'],
    },
    {
      label: 'Work',
      link: '/dashboard/projectapp',
      roles: ['admin', 'editor'],
    },
    {
      label: 'Team',
      link: '/dashboard/team',
      roles: ['admin'],
    },
    {
      label: 'Authors',
      link: '/dashboard/authors',
      roles: ['admin'],
    },
    {
      label: 'Users',
      link: '/dashboard/users',
      roles: ['admin'],
    },
  ];


  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleProfileBtn = () => {
    setIsOpen(!isOpen);
  };

  const handleSignOut = async () => {

    try {
      await signOut(auth);
    } catch (error) {
      // Gérer les erreurs, si nécessaire
    }
  };

  const user = auth.currentUser;

  //Récupérer les données de l'utilisateur
  const [userData, setUserData] = useState(null);

  const [modalOpen, setModelOpen] = useState(false);

  const handleClose = () => {
    setModelOpen(false);
  }

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user?.uid) return;

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          setUserData(userSnap.data());
        }
      } catch (error) {
        console.error("Erreur récupération user :", error);
      }
    };
    fetchUserData();

    //Déconnecter l'utilisateur après 30 minutes d'inactivité
    if (user) {
      const disconnectTimeOut = async () => {
        let timeoutId;

        function inactivityCallback() {
          signOut(auth);
          navigate("/auth");
        }

        function resetTimer() {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(inactivityCallback, 30 * 60 * 1000); // 30 * 60 * 1000 = 30 minutes
        }

        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
      }
      disconnectTimeOut();
    }
  }, [user]);


  const [countdown, setCountdown] = useState(7); // Initialiser le décompte à 7 secondes

  const updateCountdown = () => {
    // Décrémenter le décompte
    setCountdown(prevCountdown => prevCountdown - 1);
  };

  useEffect(() => {
    // Vérifier si userData?.autorisation est false avant d'initialiser le minuteur
    if (userData?.autorisation === false) {
      setModelOpen(true);
      const timerInterval = setInterval(updateCountdown, 1000);

      // Nettoyer le minuteur lorsque le composant est démonté ou lorsque l'autorisation devient true
      return () => {
        clearInterval(timerInterval);
      };
    }
  }, [userData?.autorisation]);

  // Effectuer une action lorsque le décompte atteint zéro
  useEffect(() => {
    if (countdown === 0) {
      // Exécuter la fonction de déconnexion après le décompte
      handleClose();
      signOut(auth);
    }
  }, [countdown]);

  const location = useLocation();

  const isActiveLink = (path) => {
    if (path === '/dashboard/blogapp') {
      return location.pathname.startsWith('/dashboard/blogapp');
    }
    if (path === '/dashboard/projectapp') {
      return location.pathname.startsWith('/dashboard/projectapp');
    }
    if (path === '/dashboard/team') {
      return location.pathname.startsWith('/dashboard/team');
    }
    if (path === '/dashboard/authors') {
      return location.pathname.startsWith('/dashboard/authors');
    }
    if (path === '/dashboard/users') {
      return location.pathname.startsWith('/dashboard/users');
    }

    return location.pathname === path;
  };

  const userRole = userData?.role;

  const filteredSidebarList = sidebarList.filter(item =>
    item.roles.includes(userRole)
  );

  return (
    <>
      <div className='h-screen w-screen flex'>

        <section
          className={`bg-black h-full shadow-2xl border-r min-w-[250px] max-w-[80%] flex flex-col z-50
      fixed  transition-transform duration-300
      ${isSidebarOpen ? "translate-x-0 xl:relative" : "-translate-x-full"}`}
        >

          <div className="flex justify-center items-center gap-[15px] my-10 w-full min-h-[50px] cursor-pointer bg-black" onClick={toggleProfileBtn}>
            <div className="flex flex-col items-center w-[80%] py-2 px-3 gap-[5px] bg-white border-white border-2 rounded-md shadow-2xl shadow-gray-500">

              <CgProfile className='text-black text-[80px]' />

              {userData?.displayName && (
                <p className="text-black text-[18px] font-bold">{userData?.displayName}</p>
              )}

              <div className="flex items-center justify-center gap-1">
                <div className="rounded-full bg-green-500 w-2 h-2"></div>
                <p>online</p>
              </div>

            </div>
          </div>

          <div className={`w-full h-full flex flex-col gap-5 overflow-y-scroll`}>

            <div className={`h-full w-full flex flex-col gap-5 overflow-y-scroll items-center select-none font-agrandir`}>

              {filteredSidebarList.map((item, idx) => (
                <NavLink
                  key={idx}
                  to={item.link}

                  className={isActiveLink(item.link) ? activeSidenavLinkCss : sidenavLinkCss}
                  end
                >
                  {item.label}
                </NavLink>
              ))}

              <div onClick={handleSignOut}
                className="bg-transparent text-white flex items-center gap-[10px] mt-10 mb-5 p-4 cursor-pointer text-[14px] rounded w-[80%] hover:text-black border-2 hover:bg-gray-200">
                <FaPowerOff />
                Déconnexion
              </div>

            </div>

            {/* <div className="flex justify-end p-5 w-full">
              <div className='flex flex-col items-end gap-[50px] fixed select-none font-agrandir'>

                <div className="flex justify-center items-center gap-[15px] rounded-md w-fit h-[50px] py-1 px-3 cursor-pointer bg-orange-600" onClick={toggleProfileBtn}>
                  <div className="flex items-center gap-[15px]">

                    {userData?.displayName && (
                      <p className="text-white font-bold">{userData?.displayName}</p>
                    )}

                  </div>
                  <div className="text-white">
                    {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                  </div>

                </div>

                {isOpen && (
                  <div className="absolute top-[50px] flex flex-col w-max bg-white border-2 shadow-xl rounded-b-xl">
                    <div onClick={handleSignOut} className="flex items-center gap-3 py-[10px] px-[15px] text-black border-b-2 hover:bg-gray-200 cursor-pointer"><CiPower /> Déconnexion</div>
                  </div>
                )}

              </div>
            </div> */}


          </div>

        </section>

        <section className="flex flex-col w-full overflow-y-scroll bg-black">

          <div className="flex justify-between items-center p-5 w-full">

            <img src={logo} alt="logo" className="my-[30px] xl:mx-5 mx-2.5 xl:h-[30px] h-5" />

            {/* Burger visible partout */}
            <button
              className="text-white text-3xl"
              onClick={toggleSidebar}
            >
              {isSidebarOpen ? <MdClose /> : <MdMenu />}
            </button>

          </div>

          <div className="px-5 py-10">
            <Outlet />
          </div>

        </section>

      </div>

      {modalOpen &&
        <Modal isOpen={modalOpen} onClose={handleClose}>
          <center>
            <div className='flex flex-col gap-4 items-center justify-center'>

              <p>Vous n'avez pas accès à ce site, <br /> vous allez être déconnecté !</p>
              <p className="text-red-700 text-[24px]">{countdown}</p>

            </div>
          </center>
        </Modal>
      }

    </>
  )
}

export default DashboardLayout